import { useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";

// Components
import Footer from "./Footer";

// Context
import { ConferencesContext } from "../../context/conferences";

// Utils
import { scrollToTop } from "../../utils/scrollUtils";

const FooterContainer = (props) => {
    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * useContext
     */

    const { conferences } = useContext(ConferencesContext);

    /**
     * useMemo
     */

    const footerConferences = useMemo(() => {
        return {
            "london-2022": conferences.find(
              (conference) => conference.slug === "london-2022"
            ),
            "nyc-2021": conferences.find(
              (conference) => conference.slug === "nyc-2021"
            ),
            "europe-2020": conferences.find(
                (conference) => conference.slug === "europe-2020"
            ),
            "nyc-2020": conferences.find(
                (conference) => conference.slug === "nyc-2020"
            ),
        };
    }, [conferences]);

    /**
     * End Hooks
     */

    function goToConferences() {
        const path = window.location.pathname;
        if (path !== "/conferences") {
            history.push("/conferences");
        }
        scrollToTop();
    }

    return (
        <Footer
            {...props} history={history}
            goToConferences={goToConferences}
            footerConferences={footerConferences}
        />
    );
};

export default FooterContainer;
